import { Row, Col } from 'react-bootstrap';
import ValidationInput from './ValidationTextInput';
import StateSelect from './StateSelect';

const EditAddress = () => {
  return (
    <>
      <Row>
        <ValidationInput
          name="address"
          label=""
          placeholder="Address"
          aria-label="company-address-input"
        />
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <ValidationInput
            aria-label="company-city-input"
            name="city"
            label=""
            placeholder="City"
          />
        </Col>
        <Col xs={12} md={6} className="mb-3">
          <StateSelect />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <ValidationInput
            aria-label="company-zipcode-input"
            name="zip"
            label=""
            placeholder="Zip Code"
          />
        </Col>
      </Row>
    </>
  );
};

export default EditAddress;
